<template>
  <div class="visitor-card">
    <el-card class="card visitor-box" shadow="hover">
      <template #header v-if="!globalData.nicknameLockStatus">
        <i class="el-icon-user-solid el-card-header-icon" />
        <span class="el-card-header-txt">游客设置</span>
      </template>
      <!-- <p v-if="!globalData.nicknameLockStatus" class="tip-1">你的昵称: {{globalData.nickname}}</p> -->
      <el-input :modelValue="globalData.nickname" @input="changeNickname" placeholder="请输出你的昵称" size="small" :disabled="globalData.nicknameLockStatus">
        <template #suffix>
          <el-tooltip :content="btnLockTipTxt" effect="light" placement="right">
            <el-button :type="btnLockTxt" icon="el-icon-unlock" size="mini" @click="changeNicknameLockStatus(!globalData.nicknameLockStatus)" />
          </el-tooltip>
        </template>
      </el-input>
      <p v-if="!globalData.nicknameLockStatus" class="tip-2 el-fade-in">你将以该昵称进行留言, 评论等操作, 起个好听的名字吧!</p>
    </el-card>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { useGlobal, useLog } from '@/hooks'
import { ElMessage } from 'element-plus'

export default defineComponent({
  setup() {
    // Hooks
    // eslint-disable-next-line
    const l = useLog()
    const { globalData, updateNickname, updateNicknameLockStatus } = useGlobal()

    // Computed
    const btnLockTxt = computed(() =>
      globalData.nicknameLockStatus ? 'info' : 'primary'
    )
    const btnLockTipTxt = computed(() =>
      globalData.nicknameLockStatus ? '解锁' : '锁定'
    )

    // Method
    // 改变游客昵称
    const changeNickname = (newNickname: string) => updateNickname(newNickname)
    // 改变游客昵称锁定状态
    const changeNicknameLockStatus = (newStatus: boolean) => {
      updateNickname((globalData.nickname as string).trim())
      if (!globalData.nicknameLockStatus && globalData.nickname == '') {
        ElMessage.error('亲, 你必须提供一个昵称哦.')
        return
      }
      updateNicknameLockStatus(newStatus)
      // ElNotification.success({
      //   title: '欢迎',
      //   message:`欢迎你${globalData.nickname}`
      // })
    }

    return {
      globalData,
      btnLockTxt,
      btnLockTipTxt,
      changeNickname,
      changeNicknameLockStatus,
    }
  },
})
</script>


<style lang="scss" scoped>
.visitor-card {
  .visitor-box {
    transition: all 0.5s;
  }
}
</style>